<forge-card>
    <div fxLayout="column" fxLayoutAlign="stretch start">
        <div fxFlexFill fxLayout="row" fxLayoutAlign="space-around center">
            <labeled-field label="Filename" fxFlex>
                <span>{{fileName}}</span>
            </labeled-field>

            <labeled-field label="Type" fxFlex="15">
                <truncate-text [mainText]="type"></truncate-text>
            </labeled-field>

            <labeled-field label="Added Date" fxFlex="15">
                <span>{{addedDate | date: 'M/d/yyyy'}}</span>
                <forge-tooltip>{{addedDate | date: 'EEEE, MMMM d, y h:mm:ss a'}}</forge-tooltip>
            </labeled-field>

            <labeled-field label="Added By" fxFlex="25">
                <span>{{addedBy}}</span>
            </labeled-field>

            <command-bar [commands]="commands">
            </command-bar>
        </div>

        <div *ngIf="invalid" fxLayout="column" fxLayoutAlign="stretch start"
             class="error-red forge-typography--subheading1">
            <div *ngIf="hasError('max')">
                The file is too large to upload. The max upload size is {{maxFileSize | fileSize}}
            </div>
            <div *ngIf="hasError('fileType')">
                The file has an incompatible type. The accepted types are: {{supportedFileTypes}}
            </div>
        </div>
    </div>
</forge-card>
